import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import FaBan from 'react-icons/lib/fa/ban'
import Title from './Title'
import Signers from './Signers'
import FeaSigners from './FeaSigners'
import Actions from './Actions'
import Viewers from './Viewers'
import MdErrorOutline from 'react-icons/lib/md/error-outline'
import moment from 'moment'
import BioSigners from './BioSigners'

@withGraphQL(
  gql`
    query verifyDocument($documentId: ID!) {
      verifyDocument(documentId: $documentId) {
        _id
        name
        description
        signers {
          name
          email
        }
        feaSigners {
          name
          email
        }
        bioSigners {
          name
          email
          rut
          estado
          signedAt
        }
        activities {
          action
          date
          userEmail
          ip
        }
        viewers {
          name
          email
        }
        isPublic
        documentStatus {
          status
        }
      }
    }
  `,
  {options: {errorPolicy: 'ignore'}}
)
export default class Verify extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    verifyDocument: PropTypes.object,
    documentId: PropTypes.string,
    error: PropTypes.func
  }

  state = {}

  render() {
    if (this.props.verifyDocument._id > 0 && this.props.verifyDocument._id < 100) {
      return (
        <div className={styles.container}>
          <h4>
            No exíste el documento <MdErrorOutline size={25} />{' '}
          </h4>
        </div>
      )
    }
    //console.log(JSON.stringify(this.props.verifyDocument))
    if (this.props.verifyDocument.activities) {
      return (
        <div className={styles.container}>
          {<Title verifyDocument={this.props.verifyDocument} />}
          {<Signers verifyDocument={this.props.verifyDocument} />}
          {<BioSigners verifyDocument={this.props.verifyDocument} />}
          {<FeaSigners verifyDocument={this.props.verifyDocument} />}
          {<Actions verifyDocument={this.props.verifyDocument} />}
          {<Viewers verifyDocument={this.props.verifyDocument} />}
        </div>
      )
    } else {
      return (

        <div className="section">
          <div className="header">
              <div className="row">
                <h4>
                    Documento es privado <FaBan size={25} />{' '}
                </h4>
              </div>
              <div className="row">
                    Nombre: {this.props.verifyDocument.name}
              </div>
              <div className="row">
                    Creado: 
                    {moment(this.props.verifyDocument.createdAt).format('DD/MM/YYYY HH:mm')}
                     
              </div>
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/DocumentVerify/Main/Verify/index.js